// Dependencias generales
import React from "react";

// Función del router
const FormValidationError = (params) => {
  
  return (
    <div id="divErrorValidacionFormulario" className="message error left hidden">
      <h1 className="title"><span className="material-icon">warning</span>Debes rellenar los campos en rojo para continuar</h1>
    </div>
  )
}

export default FormValidationError